<template>
    <v-container class="filter-bg" pt-2>
        <v-layout column light v-if="$uCan({rid: 'CloseCashierFilter.filters', op: 'S'})">

                <a-autocomplete-field :filterBy="{storeId: selectedStore}" @onSelect="onUserSelect" clearable
                                      label="Usuário" obj="employee"
                                      placeholder="selecionar usuário" ref="userField"
                                      v-model="filterData.userId">
                    <template slot="content" slot-scope="{data}">
                        <v-layout column>
                            <v-list-tile-title style="height: 18px;" v-text="data.name"></v-list-tile-title>
                            <v-list-tile-sub-title class="py-0">{{`${data.mobile_number}`}}</v-list-tile-sub-title>
                        </v-layout>
                    </template>
                </a-autocomplete-field>

                <v-expand-transition>
                    <v-flex pb-3 v-if="selectedReport">
                        <v-chip close color="blue-grey lighten-1" text-color="white" v-model="reportFilter">
                            <v-avatar>
                                <v-icon color="white" small>fas fa-file-alt</v-icon>
                            </v-avatar>
                            {{selectedReport}}
                        </v-chip>
                    </v-flex>
                </v-expand-transition>

                <v-flex>
                    <v-timeline align-top dense light>
                        <v-timeline-item :color="(report.difference >= 0) ? 'green lighten-1' : 'red lighten-2'"
                                         :key="index" light small v-for="(report,index) in reports">
                            <v-layout @click="showReport(report)" class="report-link" pt-3>
                                <v-flex xs4>
                                    <strong>{{$moment(report.closed_at).format('MM/DD/YYYY')}}</strong>
                                    <div class="caption">{{$moment(report.closed_at).format('h:mm a')}}</div>
                                </v-flex>
                                <v-flex>
                                    <strong v-if="report.details">Cheques: {{report.details.checks | fmtMoney}}</strong>
                                    <div class="caption" v-if="report.details">Recebíveis: {{report.details.paymts |
                                        fmtMoney}}
                                    </div>
                                    <div class="caption">#{{report.id}}</div>
                                </v-flex>
                            </v-layout>
                        </v-timeline-item>

                    </v-timeline>

                </v-flex>

        </v-layout>

        <v-layout column v-else pt-4 pl-2>
            <v-label>Nenhum Filtro Configurado</v-label>
        </v-layout>

    </v-container>
</template>

<script>

   export default {

      props: {
         reloadKey: {
            type: Number,
            required: false
         },
         execute: {
            type: Boolean,
            required: false,
            default: false
         }
      },

      data() {
         return {
            filterData: {
               userId: null,
               closeReportId: null
            },

            reportFilter: false,
            selectedReport: null,
            selectedUser: null,
            reports: null

         };
      },

      computed: {
         selectedStore() {
            return this.$store.state.company.selectedStore;
         }
      },

      watch: {
         reloadKey: {
            immediate: true,
            handler: function () {
               this.$nextTick(() => this.reloadFilters());
            }
         },
         execute(val) {
            val && this.applyFilter();
         },

         'filterData.userId': {
            immediate: true,
            handler: function (val) {
               this.reportFilter = false;
               if (val) {
                  this.$api.dataService.search('closeReport', {userId: val, origin: 'E'})
                     .then((data) => this.reports = data ? data.splice(0, 30) : null);
               } else {
                  this.reports = null;
                  this.filterData.closeReportId = null;
               }
            }
         },

         reportFilter(val) {
            if (!val) {
               this.filterData.closeReportId = null;
               this.selectedReport = null;
            }
         }

      },

      methods: {
         showReport(report) {
            this.reportFilter = true;
            this.filterData.closeReportId = report.id;
            this.selectedReport = `Caixa #${report.id}  de ${this.$moment(report.closed_at).format('MM/DD/YYYY h:mm a')}`;
         },

         onUserSelect(data) {
            this.selectedUser = data;
         },

         applyFilter() {
            let filters = [];

            filters.push({
               field: 'userId',
               value: this.filterData.userId || this.$store.state.company.user.id,
               label: this.selectedUser ? this.selectedUser.name : this.$store.state.company.user.name
            });

            filters.push({
               field: 'storeId',
               value: this.selectedUser ? this.selectedUser.companyId : this.$store.state.company.selectedStore,
               label: this.selectedUser ? this.selectedUser.storeName : this.$store.state.company.selectedStoreName
            });

            /*if (this.filterData.closeReportId) {
               filters.push({
                  field: 'closeReportId',
                  value: this.filterData.closeReportId,
                  label: ''
               });
            }*/

            if (!this.filterData.closeReportId)
               this.$store.dispatch('updateAllPageFilters', filters);

            setTimeout(() => {
               this.$emit('close');
               if (this.filterData.closeReportId) {
                  this.$router.push({path: '/closeCashier/' + this.filterData.closeReportId});
               } else if (this.$route.params.id !== 'new') {
                  this.$router.push({path: '/closeCashier/new'});
               }
            }, 150);

         },

         reloadFilters() {
            // console.log('reloaded!', this.$store.getters.activePageFilters);
            this.$util.updateObj(this.filterData, this.$store.getters.activePageFilters);

            if (!this.filterData.dateRange) {
               this.filterData.dateRange = [null, null];
            }

         }
      }
   };
</script>

<style scoped>
    .filter-bg {
        color: #444;
        background-color: white;
    }

    .report-link {
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// src/pages/CloseCashierFilter.vue